/**
 * Thin wrapper that makes any child draggable+sortable via @dnd-kit.
 * Renders a drag handle (GripVertical) on the left and forwards motion
 * transforms to the wrapper. Drag handle is only visible/usable inside the
 * SortableList container (see `SortableList`).
 */
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

export const SortableRow = ({ id, children, disabled = false, testid }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 30 : 'auto',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="relative flex items-stretch"
      data-testid={testid}
    >
      {!disabled && (
        <button
          type="button"
          aria-label="Drag to reorder"
          className="hidden sm:flex items-center justify-center w-6 -ml-1 mr-1 text-muted-foreground/40 hover:text-muted-foreground cursor-grab active:cursor-grabbing touch-none"
          {...attributes}
          {...listeners}
          data-testid={testid ? `${testid}-handle` : undefined}
        >
          <GripVertical className="h-4 w-4" strokeWidth={1.5} />
        </button>
      )}
      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
};
